import React from 'react'
import Image from '@dustin-web/microsite-components/src/image'

const mcid = {
  src: 'https://media.dustin.eu/content/88620/mcid.svg',
  width: 125,
  height: 36,
}
const tryggehandel_se = {
  src: 'https://media.dustin.eu/content/88702/tryggehandel_se.svg',
  width: 38,
  height: 38,
}
const tryggehandel_no = {
  src: 'https://media.dustin.eu/content/88699/trygg-e-handel-no.png',
  width: 44,
  height: 44,
}
const verifiedbyvisa = {
  src: 'https://media.dustin.eu/content/88634/verifiedbyvisa.svg',
  width: 40,
  height: 40,
}
const pricerunner_se = {
  src: 'https://media.dustin.eu/content/88704/pricerunner_se.png',
  width: 178,
  height: 35,
}
const pricerunner_dk = {
  src: 'https://media.dustin.eu/content/88705/pricerunner_dk.png',
  width: 178,
  height: 35,
}

export const FooterCertificates = ({ site }: { site: string }) => {
  switch (site) {
    case 'DustinSweden':
      return (
        <>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...mcid} alt="mcid" />
          </div>
          <div className="u-mb-8 u-mb-sm-0 d-flex">
            <Image {...verifiedbyvisa} alt="verifiedbyvisa" />
          </div>
        </>
      )
    case 'DustinHomeSweden':
      return (
        <>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...mcid} alt="mcid" />
          </div>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...verifiedbyvisa} alt="verifiedbyvisa" />
          </div>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...tryggehandel_se} alt="tryggehandel_se" />
          </div>
          <a
            href="https://www.pricerunner.se/info/buyer-protection"
            target="_blank"
            className="u-mb-8 u-mb-sm-0 u-button-opacity d-flex"
            rel="noreferrer">
            <Image {...pricerunner_se} alt="pricerunner_se" />
          </a>
        </>
      )
    case 'DustinHomeNorway':
      return (
        <>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...mcid} alt="mcid" />
          </div>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...verifiedbyvisa} alt="verifiedbyvisa" />
          </div>
          <a
            href="https://www.tryggehandel.no/butikker/dustin-norway/#intcmp=Footer-trygg-ehandel-20150219"
            target="_blank"
            className="u-mb-8 u-mb-sm-0 d-flex"
            rel="noreferrer">
            <Image {...tryggehandel_no} alt="tryggehandel_no" />
          </a>
        </>
      )
    case 'DustinHomeDenmark':
      return (
        <>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...mcid} alt="mcid" />
          </div>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...verifiedbyvisa} alt="verifiedbyvisa" />
          </div>
          <a
            href="https://www.pricerunner.dk/info/buyer-protection"
            target="_blank"
            className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex u-button-opacity"
            rel="noreferrer">
            <Image {...pricerunner_dk} alt="pricerunner_dk" />
          </a>
        </>
      )
    case 'DustinDenmark':
    case 'DustinFinland':
    case 'DustinHomeFinland':
    case 'DustinNetherlands':
    case 'DustinHomeNetherlands':
    case 'DustinNorway':
      return (
        <>
          <div className="u-mr-16 u-mb-8 u-mb-sm-0 d-flex">
            <Image {...mcid} alt="mcid" />
          </div>
          <div className="u-mb-8 u-mb-sm-0 d-flex">
            <Image {...verifiedbyvisa} alt="verifiedbyvisa" />
          </div>
        </>
      )
    default:
      return null
  }
}
